import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import Home from '../views/HomeMap.vue'
import Login from '../views/Login.vue'
import Mapa from '../components/GoogleMapKML/MapKML.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta:{
      libre:true
    }
  },
  {
    path: '/Map',
    name: 'Map',
    component: Mapa,
    meta:{
      libre:true
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {  

  var end = Vue.prototype.$moment.unix(store.state.expire)
  var actual = Vue.prototype.$moment.utc();
  var duration = Vue.prototype.$moment.duration(end.diff(actual));

  if(to.path == "/logout"){
    store.dispatch("logout")
    sessionStorage.clear()
    Vue.prototype.$AuthService.logout()
    next()
  }
    
  if (to.matched.some(record => record.meta.libre)){
    next()
  }else if(store.state.habilitado != null && duration._milliseconds > 0){
    next()
  }
  else{
    next({
      name: 'Login'
    })
  }
})

export default router
